import { lazy } from "react";

const Cart = lazy(() => import("./Cart"));

export { Cart };
